export default "__VITE_ASSET__B5yna_j6__"